/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Audit_JsonInputs */

const en_fw_audit_json = /** @type {(inputs: Fw_Audit_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON`)
};

const id_fw_audit_json = /** @type {(inputs: Fw_Audit_JsonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON`)
};

/**
* | output |
* | --- |
* | "JSON" |
*
* @param {Fw_Audit_JsonInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_audit_json = /** @type {((inputs?: Fw_Audit_JsonInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Audit_JsonInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_audit_json(inputs)
	return en_fw_audit_json(inputs)
});